import { Icon } from '@/components/ui/Icon'
import type { IconName } from '@/components/ui/Icon'
import { NavLink } from 'react-router'

const tabs: { to: string; label: string; icon: IconName }[] = [
  { to: '/deck', label: 'Deck', icon: 'layout-grid' },
  { to: '/garden', label: 'Garden', icon: 'sprout' },
  { to: '/profile', label: 'Profile', icon: 'user' },
]

export function BottomTabBar() {
  return (
    <nav className="wefa-bottom-tabs">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          className={({ isActive }) => `wefa-bottom-tabs__link${isActive ? ' is-active' : ''}`}
          to={tab.to}
        >
          <Icon name={tab.icon} size={22} />
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
